<template>
    <div class="">
        <!-- <Wait_Skeleton v-if="!IsWait" /> -->
        
        <Card class="h-100" ><!-- v-if="IsWait" -->
            <template #title> </template>
            <template #content>

                <div class="grid flex justify-content-center flex-wrap">
                    <div class="col-4">
                        <div class="grid">
                            <div class="col-12">
                                <label for="MevcutSifre" class="font-bold block">Mevcut Şifre</label>
                                <Password id="MevcutSifre" v-model="MevcutSifre" class="text-base text-color "
                                    :feedback="false" toggleMask />
                            </div>
                            <div class="col-12">
                                <label for="YeniSifre" class="font-bold block">YeniSifre</label>
                                <Password id="YeniSifre" v-model="YeniSifre" class="text-base text-color "
                                    :feedback="false" toggleMask />
                            </div>
                            <div class="col-12">
                                <label for="YeniSifreTekrar" class="font-bold block">YeniSifreTekrar</label>
                                <Password id="YeniSifreTekrar" v-model="YeniSifreTekrar"
                                    class="text-base text-color " :feedback="false" toggleMask/>
                            </div>
                        </div>

                    </div>
                    <div class="col-8"></div>
                    <Divider />
                    <div class="col-12 flex justify-content-end flex-wrap">
                        <IslemYapiliyor v-if="IslemYapiliyor" />
                        <Button class="m-1" label="Tamam" icon="pi pi-check" iconPos="right" size="small"
                            severity="success" @click="this.handleClick()" autofocus :disabled="IslemYapiliyor"
                            v-if="!IslemYapiliyor" />
                    </div>
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import GlobalServis from "../../../../../services/GlobalServis";

export default {
    data() {
        return {
            IslemYapiliyor: false,
            // IsWait: false,
            MevcutSifre: "",
            YeniSifre: "",
            YeniSifreTekrar: "",

            // Validation Elements
            Valid: {
                MevcutSifre: false,
                YeniSifre: false,
                YeniSifreTekrar: false,
            }
        }
    },
    methods: {
        handleClick() {
            if (this._FormCheck()) { return; }
            this.IslemYapiliyor = true;

            let data = {
                MevcutSifre: this.MevcutSifre,
                YeniSifre: this.YeniSifre,
                YeniSifreTekrar: this.YeniSifreTekrar,
            };
            GlobalServis.GlobalServis("POST", "UpdateKullaniciSifreDegistir", data).then((res) => {
                if (res.status == 200) {
                    this.$toast.add({
                        severity: "success",
                        summary: "Başarılı",
                        detail: " Yeni şifreniz oluşturulmuştur",
                        life: 3000,
                    });
                    this._ResetForm();
                } else if (res.response.status === 999) {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Uyarı",
                        detail: res.response.data,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Hata",
                        detail: "Hata oldu",
                        life: 3000,
                    });
                }
            }).then(() => {
                this.IslemYapiliyor = false;
            });
        },
        _ResetForm() {
            this.IslemYapiliyor = false;
            this.IsWait = false;
            this.MevcutSifre = "";
            this.YeniSifre = "";
            this.YeniSifreTekrar = "";

            // Validation Elements
            this.Valid.MevcutSifre = false;
            this.Valid.YeniSifre = false;
            this.Valid.YeniSifreTekrar = false;
        },
        _FormCheck() {
            let Check = false;
            if (this.MevcutSifre === "") {
                this.Valid.MevcutSifre = true;
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Mevcut şifrenizi girin", life: 3000, });
                Check = true;
                return Check;
            } else { this.Valid.MevcutSifre = false; Check = false; }
            if (this.YeniSifre === "") {
                this.Valid.YeniSifre = true;
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Yeni şifrenizi girin", life: 3000, });
                Check = true;
                return Check;
            } else { this.Valid.YeniSifre = false; Check = false; }
            if (this.YeniSifreTekrar === "") {
                this.Valid.YeniSifreTekrar = true;
                this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Yeni şifrenizi tekrar girin", life: 3000, });
                Check = true;
                return Check;
            } else { this.Valid.YeniSifreTekrar = false; Check = false; }

            return Check;
        },

    },
    mounted() {
        // this.IsWait = true;
    },
    components: {
    },

}
</script>